
































import {
  Component,
  Vue,
} from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import store from '@/store/store';
import Spinner from '@/components/Spinner.vue';

@Component({
  components: {
    Spinner,
  },
})
export default class Login extends Vue {

  @Action private addTokenAsync: any;
  @Action private changeOrganisationAsync: any;

  @Getter private organisations: any;
  @Getter private lastOrganisation: any;


  private backgroundImage: string = '';

  private mode: string = 'login';
  private loginForm = {
    email: '',
    password: '',
  };
  private loginFailed: boolean = false;
  private haveToken: boolean = false;

  private resetForm = {
    confirm_password: '',
    password: '',
    token: '',
  };

  private backgroundImages: string[] = [
    'agriculture',
    'beach',
    'bridge',
    'city',
    'construction',
    'docks',
    'housing',
    'lulworth',
    'market',
    'new_forest',
    'peak',
    'rail',
    'river',
    'solar',
    'traffic',
    'warehouse',
    'water',
  ];

  public async mounted() {
    if (this.$route.query.code !== undefined && this.$route.query.code.length > 0) {
      this.haveToken = true;
      if (this.$route.query.code !== 'USED') {
        await this.doLogin();
      }
    } else {
      this.haveToken = false;
    }
  }

  public redirectToLogin() {
    if (this.$route.query.redirect && this.$route.query.redirect !== '/404') {
      localStorage.setItem('login_redirect', String(this.$route.query.redirect));
    } else {
      localStorage.removeItem('login_redirect');
    }

    location.replace(`${process.env.VUE_APP_COGNITO_HOST}/login?response_type=code&client_id=${process.env.VUE_APP_COGNITO_CLIENT_ID}&redirect_uri=${location.protocol}//${window.location.host}/login&scope=email+openid+profile+aws.cognito.signin.user.admin`);
  }

  private async doLogin() {
    this.loginFailed = false;
    const token = await this.addTokenAsync({
      code: this.$route.query.code,
      redirectUri: `${window.location.origin}${this.$route.path}`,
    });
    this.$route.query.code = 'USED'; // Debounce mounted by marking the code as used.
    if (!token) {
      this.haveToken = false;
      this.loginFailed = true;
      return;
    }
    if (this.lastOrganisation && store.getters.organisations.organisations.some((org: any) => org.id === this.lastOrganisation)) {
      await this.changeOrganisationAsync({
        orgId: this.lastOrganisation,
        forceRender: false,
      });
    }

    let destination = this.$route.query.redirect;
    if (!destination) {
      const stashedRedirect = localStorage.getItem('login_redirect');
      if (stashedRedirect) {
        destination = stashedRedirect;
        localStorage.removeItem('login_redirect'); // clean up redirect
      }
    }

    if (destination) {
      this.$router.replace(String(destination));
    } else {
      this.$router.replace('/');
    }
  }

  private showLogin() {
    return this.mode === 'login' && !this.haveToken;
  }

  private switchToLogin() {
    this.mode = 'login';
    this.$router.push('/login');
  }

  private redirectToForgotPassword() {
    location.replace(`${process.env.VUE_APP_COGNITO_HOST}/forgotPassword?response_type=code&client_id=${process.env.VUE_APP_COGNITO_CLIENT_ID}&redirect_uri=${location.protocol}//${window.location.host}/login&scope=email+openid+profile+aws.cognito.signin.user.admin`);
  }

  private getBackgroundImage() {
    if (!this.haveToken) {
      if (!this.backgroundImage.length) {
        const randomIndex = Math.floor(Math.random() * this.backgroundImages.length);
        this.backgroundImage = require(`../assets/images/login-backgrounds/daizy_${this.backgroundImages[randomIndex]}.jpg`);
      }
      return this.backgroundImage;
    }
    return '';
  }
}
